import { useState } from "react";
import { Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H4, P } from "../../../../AbstractElements";
import { Href } from "../../../../utils/Constant";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const OtpLogin = () => {
  const { t } = useTranslation();
  const [otpSent, setOtpSent] = useState(false);

  const handleSendOtp = () => {
    // Here you would typically handle the logic for sending the OTP
    setOtpSent(true);
  };

  return (
    <div className="page-wrapper">
      <Container fluid className="p-0">
        <Row>
          <Col xs="12">
            <div className="login-card login-dark">
              <div>
                <div>{/* <CommonLogo /> */}</div>
                <div className="login-main">
                  <Form
                    className="theme-form"
                    onSubmit={(event) => event.preventDefault()}
                  >
                    <H4>{t("otpLogin")}</H4>
                    <FormGroup>
                      <Label className="col-form-label">
                        {t("enterYourEmail")}
                      </Label>
                      <Row>
                        <Col xs="12">
                          <Input
                            className="mb-1"
                            type="email"
                            placeholder={t("emailPlaceholderOtp")}
                            disabled={otpSent}
                          />
                        </Col>
                        {!otpSent && (
                          <Col xs="12">
                            <div className="text-end">
                              <Btn
                                block
                                color="primary"
                                className="m-t-10"
                                onClick={handleSendOtp}
                              >
                                {t("send")}
                              </Btn>
                            </div>
                          </Col>
                        )}
                      </Row>
                    </FormGroup>
                    {otpSent && (
                      <>
                        <div className="mt-4 mb-4">
                          <span className="reset-password-link">
                            {t("didNotReceiveOtp")}
                            <Link className="btn-link text-danger" to={Href}>
                              {t("resend")}
                            </Link>
                          </span>
                        </div>
                        <FormGroup>
                          <Label className="col-form-label pt-0">
                            {t("enterOtp")}
                          </Label>
                          <Row>
                            {[...Array(6)].map((_, index) => (
                              <Col key={index}>
                                <Input
                                  className="text-center opt-text"
                                  type="text"
                                  defaultValue=""
                                  maxLength={1}
                                />
                              </Col>
                            ))}
                          </Row>
                        </FormGroup>
                        <FormGroup className="mb-0">
                          <Btn color="primary" block className="w-100">
                            {t("submit")}
                          </Btn>
                        </FormGroup>
                      </>
                    )}
                    <P className="mt-4 mb-0 text-center">
                      {t("wantToLoginWithPassword")}
                      <Link className="ms-2" to={`/authentication/loginsimple`}>
                        {t("loginWithPassword")}
                      </Link>
                    </P>
                  </Form>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default OtpLogin;
